import { api } from "./api";
import { toast } from "sonner";

// Descarga un CFDI (PDF/XML) autenticado desde el backend y lo guarda.
export async function downloadCFDI(url, filename) {
  try {
    const { data } = await api.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
  } catch (e) {
    toast.error("No se pudo descargar el archivo");
  }
}
